var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseLineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_476_511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88397 0.676961C10.0387 0.522258 10.0387 0.271362 9.88397 0.116577C9.72926 -0.038208 9.47836 -0.038208 9.32358 0.116577L5.00002 4.44006L0.676463 0.116577C0.521757 -0.038208 0.270858 -0.038208 0.115989 0.116577C-0.0387182 0.271281 -0.0387182 0.522258 0.115989 0.676961L4.43971 5.00037L0.11607 9.32393C-0.0386362 9.47864 -0.0386362 9.72953 0.11607 9.88432C0.270858 10.0391 0.521757 10.0391 0.676544 9.88432L5.0001 5.56083L9.32358 9.88432C9.47828 10.0391 9.72918 10.0391 9.88397 9.88432C10.0387 9.72961 10.0387 9.47872 9.88397 9.32393L5.56041 5.00037L9.88397 0.676961Z",
    fill: "#3B0532"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_476_511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "matrix(-1 0 0 1 10 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLineIcon);
export default __webpack_public_path__ + "static/media/close-line-icon.9a9dd3260cdd82c9170c0a00a8a25655.svg";
export { ForwardRef as ReactComponent };